// ============================================================
// Datei: src/pages/ressorts/hang/Hang.jsx
// 🔥 FIX:
// - reloadVolunteers abgesichert
// ============================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import Api from "../../../Api";

import HangDesktop from "./HangDesktop";
import HangMobile from "./HangMobile";
import useMediaQuery from "../../../hooks/useMediaQuery";

const Hang = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	// ============================================================
	// VOLUNTEERS
	// ============================================================

	const volunteersHook = useVolunteers("Hang");
	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];

	// 🔥 FIX: fallback wie bei anderen Ressorts
	const reloadVolunteers =
		typeof volunteersHook[2] === "function"
			? volunteersHook[2]
			: async () => {
				try {
					const res = await Api.get("/volunteers?department=Hang");
					setVolunteers([...res.data]);
				} catch (err) {
					console.error("❌ Reload Volunteers Fehler:", err);
				}
			};

	// ============================================================
	// SHIFTS
	// ============================================================

	const [initialShifts] = useShifts("Hang");
	const [shifts, setShifts] = useState([]);

	useEffect(() => {
		setShifts(initialShifts);
	}, [initialShifts]);

	const reloadShifts = async () => {
		try {
			const res = await Api.get("/shifts?department=Hang");
			setShifts([...res.data]);
		} catch (err) {
			console.error("❌ Reload Shifts Fehler:", err);
		}
	};

	// ============================================================
	// STATE
	// ============================================================

	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	// ============================================================
	// SECURITY
	// ============================================================

	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "hang") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		loadGuests();
		reloadVolunteers();
		reloadShifts();

	}, [navigate]);

	const loadGuests = () => {
		Api.get("/guests").then(res => setGuests(res.data));
	};

	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", {
				responseType: "blob"
			});

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			a.click();

			window.URL.revokeObjectURL(url);

		} catch (err) {
			console.error("CC-Download Fehler:", err);
		}
	};

	const layoutProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers,

		shifts,
		reloadShifts,

		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests: loadGuests,
		downloadCcEmails
	};

	return (
		<div
			className="hang-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_hang.jpg`}
		>
			<h2 className="hang-heading">Hang</h2>

			{isMobile
				? <HangMobile {...layoutProps} />
				: <HangDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Hang;